import { Injectable } from '@angular/core';
import { Subscription, Subject } from 'rxjs';

@Injectable()
export class SplashScreenStateService {
   subject = new Subject();
   // subject2 = new Subject();
   // subject3 = new Subject();


   subscribe(onNext: any): Subscription {
      return this.subject.subscribe(onNext);
   }

   stop() {
      this.subject.next(false);
    //  this.subject = null;
   }
   // subscribe2(onNext: any): Subscription {
   //    return this.subject.subscribe(onNext);
   // }
   dataReturned2() {
      this.subject.next(false);

    //  alert('here');
   }
   // subscribe3(onNext: any): Subscription {
   //    return this.subject.subscribe(onNext);
   // }
   dataReturned3() {
      this.subject.next(false);

    //  alert('here');
   }

}